module.exports = __webpack_public_path__ + "img/cptgb-3.d5fde220.png";